export default __webpack_public_path__ + "static/media/080_finish_good.first.ef06f4fe.png";